// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.VJDxbzYvijNvojYHuhXw .DxGXLX3p0why1Vh3NSFX {
  margin: 60px 0;
}

.krPrgyGuTvv3qN1a_hR4 {
  position: fixed !important;
  top: 0 !important;
  z-index: 9999 !important;
  height: 100vh !important;
  background: #ffffff;
  width: 100%;
}
.krPrgyGuTvv3qN1a_hR4 .offcanvas-body {
  overflow: auto;
  height: calc(100vh - 50px);
  width: 100%;
}
.krPrgyGuTvv3qN1a_hR4 .offcanvas-title h2 {
  border-bottom: 1px solid #C3CFE7;
  padding: 0 0 15px 0;
  margin: 0;
}

.FIS20LzoFh9izD6wTldx {
  float: left;
  background-color: transparent;
  border: 0;
}
.FIS20LzoFh9izD6wTldx svg {
  fill: #0C3058;
}`, "",{"version":3,"sources":["webpack://./GeneralComponents/SearchResults/Search.module.scss"],"names":[],"mappings":"AAEI;EACI,cAAA;AADR;;AAMA;EACI,0BAAA;EACA,iBAAA;EACA,wBAAA;EACA,wBAAA;EACA,mBAAA;EACA,WAAA;AAHJ;AAKI;EACI,cAAA;EACA,0BAAA;EACA,WAAA;AAHR;AAOQ;EACI,gCAAA;EACA,mBAAA;EACA,SAAA;AALZ;;AAUA;EACI,WAAA;EACA,6BAAA;EACA,SAAA;AAPJ;AAQI;EACI,aAAA;AANR","sourcesContent":[".search-container {\r\n\r\n    .no-results {\r\n        margin: 60px 0;\r\n    }\r\n}\r\n\r\n\r\n.offcanvas-filters {\r\n    position: fixed !important;\r\n    top: 0 !important;\r\n    z-index: 9999 !important;\r\n    height: 100vh !important;\r\n    background: #ffffff;\r\n    width: 100%;\r\n\r\n    :global(.offcanvas-body) {\r\n        overflow: auto;\r\n        height: calc(100vh - 50px);\r\n        width: 100%;\r\n    }\r\n\r\n    :global(.offcanvas-title) {\r\n        h2 {\r\n            border-bottom: 1px solid #C3CFE7;\r\n            padding: 0 0 15px 0;\r\n            margin: 0;\r\n        }\r\n    }\r\n}\r\n\r\n.close-button {\r\n    float: left;\r\n    background-color: transparent;\r\n    border: 0;\r\n    svg {\r\n        fill: #0C3058;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"search-container": `VJDxbzYvijNvojYHuhXw`,
	"no-results": `DxGXLX3p0why1Vh3NSFX`,
	"offcanvas-filters": `krPrgyGuTvv3qN1a_hR4`,
	"close-button": `FIS20LzoFh9izD6wTldx`
};
export default ___CSS_LOADER_EXPORT___;
